enum HttpPathsEnum {
  USERS = 'users/api',
  COMPANY = 'customers/api',
  RESOURCE = 'resources/api',
  EVENTS = 'events/api',
  CUSTOMERS = 'customers/api',
  SERVICES = 'services/api',
}

export default HttpPathsEnum;
